import { RbacPermissions } from '../../core/interfaces/user';
import { TeamSettingsService } from '../../core/services/team-settings.service';
import { UserService } from '../../core/services/user.service';

export class RbacService {
  static deps = [
    TeamSettingsService,
    UserService
  ];

  constructor(
    private _teamSettingsService: TeamSettingsService,
    private _userService: UserService,
  ) {
  }

  canTakeAction(action?: RbacPermissions) {
    if (!action || !this._teamSettingsService.isRBACEnabled()) {
      return true;
    }

    const permissionsMap = this._userService.getPermissions();
    return !!permissionsMap.get(action);
  }


  isOwnerOrHasPermission(permission: RbacPermissions) {
    return this.isRbacEnabled()
      ? this.canTakeAction(permission)
      : this._userService.getUser().isOwner
  }


  isRbacEnabled() {
    return this._teamSettingsService.isRBACEnabled();
  }
}
